import { useMemo } from 'react'

import { Loading } from 'components/controls/loading'
import { ErrorInfo } from 'components/controls/errorInfo'

import {
	Box,
	ListProps,
	List,
	Alert
} from '@mui/material'

import { useListMrpProject } from 'interface/carenet/mrp'
import { MrpProjectRecord } from './mrpProjectRecord'

type MrpProjectListProps = {
	searchId: number,
	searchWord: string,
	openMrpProject: (projectId: number, isOpenGrid: boolean) => void
} & ListProps
export const MrpProjectList = ({
	searchId,
	searchWord,
	openMrpProject,
	...others
}: MrpProjectListProps) => {
	const projectsState = useListMrpProject(true, searchId)
	const projects = useMemo(
		() => {
			if (projectsState.loading) return []
			const projects = (projectsState.data?.list || [])
				.filter(project => (
					project.projectName?.toLowerCase().includes(searchWord.toLowerCase()) ||
					project.productName?.toLowerCase().includes(searchWord.toLowerCase()) ||
					project.seriesName?.toLowerCase().includes(searchWord.toLowerCase()) ||
					project.clientName?.toLowerCase().includes(searchWord.toLowerCase())
				))
			projects.sort((a, b) => (b.startDate ?? '').localeCompare(a.startDate ?? ''))
			return projects
		},
		[projectsState, searchWord]
	)
	if (projectsState.loading) return <Loading />
	return (
		<>
			{projectsState.error && <ErrorInfo error={projectsState.error} />}
			{(projectsState.data && projects.length === 0) ? (
				<Box padding={1} height='100%' overflow='auto' boxSizing="border-box">
					<Alert severity="info">対象が見つかりません.</Alert>
				</Box>
			) : (
				<List {...others} disablePadding>
					{projects.map(project => (
						<MrpProjectRecord
							key={`mrp-project-${project.projectId}`}
							project={project}
							openMrpProject={openMrpProject}
						/>
					))}
				</List>
			)}
		</>
	)
}
